import React from "react";
import { Col, type ColProps } from "reactstrap";

type ColxxProps = ColProps & {
  xxs?: string;
  /** Legacy prop from the template; accepted and ignored. */
  widths?: unknown;
};

const Colxx = ({ xxs, widths: _widths, ...rest }: ColxxProps) => {
  const props: ColProps = { ...rest };
  if (xxs !== undefined && props.xs === undefined) {
    props.xs = xxs;
  }
  return <Col {...props} />;
};

const Separator = (props: { className?: string }) => (
  <div className={`separator ${props.className || ""}`} />
);

export { Colxx, Separator };
